// src/queries/esimBulk/useUploadDetailsCount.ts

import { useQuery } from '@tanstack/react-query';
import { getUploadHistoryDetailsCount } from '@apis/esimBulk/upload';

/**
 * Fetch the total number of upload detail rows for a given uploadId.
 *
 * This count is used for pagination controls and is independent of
 * page or filter state.
 *
 * The query is enabled only when uploadId is a positive finite number.
 */
export const useUploadDetailsCount = (uploadId: number) => {
  const enabled = Number.isFinite(uploadId) && uploadId > 0;

  return useQuery<number, Error>({
    queryKey: ['uploadDetailsCount', uploadId],
    queryFn: () => getUploadHistoryDetailsCount(uploadId),
    enabled,
  });
};
